// import { initializeApp } from 'firebase/app';
// import { getAuth } from 'firebase/auth';
// import { getFirestore } from 'firebase/firestore';
import firebase from "firebase/app";
import 'firebase/firestore';

import { authConfig, firestoreConfig } from "~/env";

// Initialize Firebase Auth
// export const authApp = initializeApp(authConfig, 'auth');
export const authApp = firebase.initializeApp(authConfig, "trust");

// Initialize Firebase Firestore
// export const firestoreApp = initializeApp(firestoreConfig, 'firestore');
export const firestoreApp = firebase.initializeApp(firestoreConfig, "db");

// export const authA = getAuth(authApp);
// export const authB = getAuth(firestoreApp);
// export const db = firebase.firestore(firestoreApp);
// export const db = firebase.firestore(firestoreApp);

export const db = firebase.firestore(firestoreApp);
